import { useTranslation } from 'next-i18next'
import { PILLAR_NAMES_EN } from 'src/constants/pillarNamesEn'
import { PILLAR_PAGE_MAP, PillarPage } from 'src/constants/searchPages'

type PillarNames = {
  /** The noun used inside sentences, e.g. "self-storage units for rent". */
  searchName: string
  /** H1 variant — falls back to `searchName` when a pillar has no override. */
  searchNameH1: string
  /** Short nav/breadcrumb form, e.g. "Self Storage". */
  label: string
}

/**
 * Locale-aware pillar display nouns.
 *
 * `PILLAR_PAGE_MAP` (a cross-repo mirror) carries the Spanish copy; English
 * comes from `PILLAR_NAMES_EN`. Read pillar nouns through this hook rather
 * than reaching into `PILLAR_PAGE_MAP` directly whenever the value is rendered
 * to a user — otherwise a Spanish noun lands inside an English sentence.
 */
export default function usePillarNames(pillar: PillarPage): PillarNames {
  const { i18n } = useTranslation()
  const es = PILLAR_PAGE_MAP[pillar]

  if (i18n.language !== 'en') {
    return {
      searchName: es.searchName,
      searchNameH1: es.searchNameH1 ?? es.searchName,
      label: es.label
    }
  }

  const en = PILLAR_NAMES_EN[pillar]
  return {
    searchName: en.searchName,
    searchNameH1: en.searchNameH1 ?? en.searchName,
    label: en.label
  }
}
